import { Box, ListItem, SvgIcon, Typography } from '@mui/material';
import ChevronRightIcon from 'assets/icons/chevron-right.svg';
import FileSignIcon from 'assets/icons/file-sign.svg';
import FileAckIcon from 'assets/icons/file.svg';
import moment from 'moment';
import { func, node, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import employeeShape from 'shapes/employee';
import ackBelongsToEmployee from 'utils/ackBelongsToEmployee';
import connector from './connector';

const DocumentItem = ({ doc, employee, actions, children, onOpened }) => {
  const preview = () => {
    if (onOpened) onOpened();
    actions.acknowledgmentReadModal.open(doc, doc.channel, employee);
  };

  const Icon = doc.digitalSignature ? FileSignIcon : FileAckIcon;
  const confirmedAt = (doc.acknowledges || []).find(a =>
    ackBelongsToEmployee(a, employee),
  )?.confirmedAt;
  const informative = doc.displayStatus === 'declined' || doc.displayStatus === 'expired';
  const stateLabel = doc.displayStatus
    ? I18n.t(`ProfileDrawer.signature status ${doc.displayStatus}`)
    : null;
  const origin = doc.channelName
    ? I18n.t(doc.isDirect ? 'Documents.From direct chat' : 'Documents.From chat', {
        chat: doc.channelName,
        name: doc.channelName,
      })
    : null;
  const signedOn = confirmedAt
    ? I18n.t(
        doc.digitalSignature
          ? 'Documents.Digital signature made on'
          : 'Documents.Acknowledge made on',
        { date: moment.unix(confirmedAt).format('LL') },
      )
    : null;
  const subtitle = [stateLabel, signedOn || origin].filter(Boolean).join(' · ') || null;
  return (
    <ListItem
      sx={{ display: 'block' }}
      onClick={informative ? undefined : preview}
      style={informative ? { cursor: 'default' } : undefined}
    >
      <Box
        sx={{
          height: '70px',
          alignItems: 'center',
          cursor: informative ? 'default' : 'pointer',
          display: 'flex',
        }}
      >
        <SvgIcon sx={{ fontSize: 24, marginRight: '10px' }}>
          <Icon />
        </SvgIcon>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: 'normal',
              fontStyle: 'normal',
              fontStretch: 'normal',
              lineHeight: '1.47',
              letterSpacing: '-0.5px',
              color: 'black',
            }}
            component="div"
          >
            {children}
          </Typography>
          {subtitle ? (
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'normal',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: '1.47',
                letterSpacing: '-0.5px',
                color: 'primary.main',
              }}
              component="div"
            >
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        {informative ? null : (
          <SvgIcon sx={{ fontSize: 14 }}>
            <ChevronRightIcon />
          </SvgIcon>
        )}
      </Box>
      <Box
        component="hr"
        sx={{
          m: 0,
          marginLeft: '30px',
          backgroundColor: 'secondary.extraLight',
          height: '1px',
          border: 0,
          flex: 'none',
        }}
      />
    </ListItem>
  );
};

DocumentItem.propTypes = {
  employee: employeeShape.isRequired,
  children: node.isRequired,
  doc: object.isRequired,
  actions: object.isRequired,
  onOpened: func,
};

export default connector(DocumentItem);
